/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketOrderStatus } from './TicketOrderStatus';
import {
    TicketOrderStatusFromJSON,
    TicketOrderStatusFromJSONTyped,
    TicketOrderStatusToJSON,
    TicketOrderStatusToJSONTyped,
} from './TicketOrderStatus';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TicketOrderListItem
 */
export interface TicketOrderListItem {
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    orderCode: string;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof TicketOrderListItem
     */
    eventId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    eventName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    buyerName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    email: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketOrderListItem
     */
    quantity: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketOrderListItem
     */
    checkedInCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof TicketOrderListItem
     */
    totalAmount: number;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    cardBrand: string | null;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    cardLast4: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TicketOrderListItem
     */
    purchasedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof TicketOrderListItem
     */
    createdAt: Date;
    /**
     * 
     * @type {TicketOrderStatus}
     * @memberof TicketOrderListItem
     */
    status: TicketOrderStatus;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderListItem
     */
    discountLabel: string | null;
}



/**
 * Check if a given object implements the TicketOrderListItem interface.
 */
export function instanceOfTicketOrderListItem(value: object): value is TicketOrderListItem {
    if (!('orderCode' in value) || value['orderCode'] === undefined) return false;
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('eventName' in value) || value['eventName'] === undefined) return false;
    if (!('buyerName' in value) || value['buyerName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('checkedInCount' in value) || value['checkedInCount'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('cardBrand' in value) || value['cardBrand'] === undefined) return false;
    if (!('cardLast4' in value) || value['cardLast4'] === undefined) return false;
    if (!('purchasedAt' in value) || value['purchasedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('discountLabel' in value) || value['discountLabel'] === undefined) return false;
    return true;
}

export function TicketOrderListItemFromJSON(json: any): TicketOrderListItem {
    return TicketOrderListItemFromJSONTyped(json, false);
}

export function TicketOrderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketOrderListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'],
        'eventId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['eventId']),
        'eventName': json['eventName'],
        'buyerName': json['buyerName'],
        'email': json['email'],
        'quantity': ApiUserTasksGetPageParameterFromJSON(json['quantity']),
        'checkedInCount': ApiUserTasksGetPageParameterFromJSON(json['checkedInCount']),
        'totalAmount': json['totalAmount'],
        'currency': json['currency'],
        'cardBrand': json['cardBrand'],
        'cardLast4': json['cardLast4'],
        'purchasedAt': (json['purchasedAt'] == null ? null : new Date(json['purchasedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'status': TicketOrderStatusFromJSON(json['status']),
        'discountLabel': json['discountLabel'],
    };
}

export function TicketOrderListItemToJSON(json: any): TicketOrderListItem {
    return TicketOrderListItemToJSONTyped(json, false);
}

export function TicketOrderListItemToJSONTyped(value?: TicketOrderListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'eventId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['eventId']),
        'eventName': value['eventName'],
        'buyerName': value['buyerName'],
        'email': value['email'],
        'quantity': ApiUserTasksGetPageParameterToJSON(value['quantity']),
        'checkedInCount': ApiUserTasksGetPageParameterToJSON(value['checkedInCount']),
        'totalAmount': value['totalAmount'],
        'currency': value['currency'],
        'cardBrand': value['cardBrand'],
        'cardLast4': value['cardLast4'],
        'purchasedAt': value['purchasedAt'] == null ? value['purchasedAt'] : value['purchasedAt'].toISOString(),
        'createdAt': value['createdAt'].toISOString(),
        'status': TicketOrderStatusToJSON(value['status']),
        'discountLabel': value['discountLabel'],
    };
}

